module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To Cheryl Ann")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("who rescued Maia from Flatland")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and me from loneliness")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4078c7c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504086356.vue
// module id = 69
// module chunks = 0